const booking = {
  bookingInformation: "预订信息", // translated
  ourCancellationPolicy: "我们的取消政策", // translated
  thisAupersedesAnyCancellationPolicyInRemarksAbove: "这取代上述评论中的任何取消政策", // translated
  thisBookingIsNonNefundable: "此预订不可退款", // translated
  paymentTerms: "付款条件", // translated
  paymentWillBeTakenFromYourDefault: "将从您的默认付款中扣除", // translated
  paymentMethod: "付款方式", // translated
  afterTheFreeCancellationPeriodIfApplicable: "免费取消期过后（如果适用）", // translated
  prebook: "预售书", // translated
  guests: "客人", // translated
  payment: "支付", // translated
  byClicking: "通过点击", // translated
  youAreAgreeingToOur: "您同意我们的", // translated
  termsAndConditions: "条款和条件", // translated
  lastBookableDate: "最后可预订日期", // translated
  customerRemarksTextfield: "客户评价", // translated
  request: "要求", // translated
  cancellationPolicy: "取消政策", // translated
};


export default booking;
